/**
 * Entry Point
 * Provana Work Allocation System
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import './styles/index.css';

// Inject mock identity headers on every axios request in dev/mock mode.
if (import.meta.env.VITE_AZURE_CLIENT_ID === 'mock-client-id-for-testing') {
  axios.interceptors.request.use((config) => {
    config.headers = config.headers ?? {};
    config.headers['X-Mock-Role']       = localStorage.getItem('mockRole')      || 'SUPERVISOR';
    config.headers['X-Mock-User-Email'] = localStorage.getItem('mockUserEmail') || '';
    config.headers['X-Mock-User-Name']  = localStorage.getItem('mockUserName')  || '';
    config.headers['X-Mock-EmpId']      = localStorage.getItem('mockEmployeeId') || '';
    return config;
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
